export default __webpack_public_path__ + "4888f0c5690bc08dcc8e8620c22b50dc.svg";